import React from "react";
import "./iFrameHeader.scss";

const IframeHeader = ({ title, department, equipment, design, iFrameNum }) => {
    return (
        <div className="iFrameHeader">
            <div className="iFrameHeader__title">{title}</div>
            <div className="iFrameHeader__info">
                <div className="iFrameHeader__info-items">
                    <div className="iFrameHeader__info-item">
                        <div className="iFrameHeader__info-item-name">Відділ:</div>
                        <div className="iFrameHeader__info-item-link">{department}</div>
                    </div>
                    <div className="iFrameHeader__info-item">
                        <div className="iFrameHeader__info-item-name">Елементи оформлення:</div>
                        <div className="iFrameHeader__info-item-link">{design}</div>
                    </div>
                    <div className="iFrameHeader__info-item">
                        <div className="iFrameHeader__info-item-name">Обладнання</div>
                        <div className="iFrameHeader__info-item-link">{equipment}</div>
                    </div>
                </div>
                <div className="iFrameHeader__info-num">{iFrameNum}</div>
            </div>
        </div>
    );
};

export default IframeHeader;
